import React from "react";
import PropTypes from "prop-types";
// Material Imports
import MuiPaper from "@mui/material/Paper";
const Paper = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiPaper, rest, children);
};
export default Paper;
Paper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sx: PropTypes.object
};